/*
 * bundle.js — PDP-Enhancement für WP 3.3 (Bundles, Packs & Mengenrabatt).
 * IIFE-guarded, defer geladen INNERHALB der main-product-Section. Dependency-free.
 *
 * Zuständig für:
 *  - pack-selector: Pill-Klick synchronisiert das Mengenfeld der Buy-Box ([data-qty-input]) und
 *    feuert dort ein 'change'-Event, sodass product.js Preis/Gesamtsumme aktualisiert. Zeigt einen
 *    Effektivpreis-Hinweis („~X €/Stück, spart Y %"). Aktive Pill folgt bidirektional dem Mengenwert.
 *  - bundle-size-switcher: markiert die aktive Größe (serverseitig bereits gesetzt; hier nur
 *    Tastatur-Komfort, da die Pills echte Links sind — kein JS-Preisdelta).
 *
 * Progressive Enhancement: ohne JS bleibt die Buy-Box voll funktionsfähig (Menge manuell,
 * Größen-Pills sind echte <a>-Links). Reduced-motion-sicher (keine Animationen hier).
 */
(function () {
  'use strict';
  if (window.HomediaBundle) return;
  window.HomediaBundle = true;

  var root = document.querySelector('[data-pdp]') || document;

  // Money-Formatter aus dem Cart-Foundation (sonst simpler Fallback).
  var money = (window.Homedia && window.Homedia.cart && window.Homedia.cart.formatMoney)
    ? window.Homedia.cart.formatMoney
    : function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };

  // =========================================================================
  // PACK-SELECTOR (Multipack / Mengenrabatt — setzt nur die Menge)
  // =========================================================================
  function initPack() {
    var pack = root.querySelector('[data-pack-selector]');
    if (!pack) return;
    var pills = pack.querySelectorAll('[data-pack-pill]');
    if (!pills.length) return;
    var qtyInput = root.querySelector('[data-qty-input]');
    var hint = pack.querySelector('[data-pack-hint]');

    var hintPlain = pack.getAttribute('data-pack-hint-plain') || '';
    var hintSave = pack.getAttribute('data-pack-hint-save') || '';

    function pillQty(pill) {
      var q = parseInt(pill.getAttribute('data-pack-qty'), 10);
      return isNaN(q) || q < 1 ? 1 : q;
    }

    function showHint(pill) {
      if (!hint) return;
      var disc = parseInt(pill.getAttribute('data-pack-discount'), 10) || 0;
      var perUnit = parseInt(pill.getAttribute('data-pack-per-unit'), 10);
      if (isNaN(perUnit) || perUnit <= 0) { hint.textContent = ''; return; }
      var perStr = money(perUnit);
      var tpl = disc > 0 ? hintSave : hintPlain;
      hint.textContent = tpl
        .replace('__per__', perStr)
        .replace('__percent__', disc);
    }

    // Pill optisch + a11y aktiv setzen.
    function setActive(pill) {
      for (var i = 0; i < pills.length; i++) {
        var on = pills[i] === pill;
        pills[i].classList.toggle('is-active', on);
        pills[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      if (pill) showHint(pill);
    }

    // Pill anhand eines Mengenwerts finden (für bidirektionale Sync).
    function pillForQty(qty) {
      var exact = null;
      for (var i = 0; i < pills.length; i++) {
        if (pillQty(pills[i]) === qty) { exact = pills[i]; break; }
      }
      return exact;
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        // Über dem Bestand gesperrte Stufe (siehe pdp:qtylimit unten) ignorieren.
        if (pill.getAttribute('aria-disabled') === 'true') return;
        setActive(pill);
        if (qtyInput) {
          qtyInput.value = pillQty(pill);
          // product.js lauscht auf 'change' → aktualisiert Preis/Gesamtsumme/Sticky UND deckelt
          // die Menge auf den Bestand. Wird dabei nach unten korrigiert, feuert product.js ein
          // weiteres 'change' — unser Listener unten setzt die aktive Pill dann passend nach.
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    // Bestands-Limit von product.js: Pack-Stufen über dem verfügbaren Bestand sperren.
    // detail.max === null → kein Limit (Bestand nicht verfolgt oder Überverkauf erlaubt).
    document.addEventListener('pdp:qtylimit', function (e) {
      var max = e.detail ? e.detail.max : null;
      pills.forEach(function (pill) {
        var over = max != null && pillQty(pill) > max;
        if (over) pill.setAttribute('aria-disabled', 'true');
        else pill.removeAttribute('aria-disabled');
      });
    });

    // Tippt der Nutzer die Menge direkt, folgt die aktive Pill (oder keine, wenn kein Match).
    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var q = parseInt(qtyInput.value, 10);
        if (isNaN(q) || q < 1) q = 1;
        var match = pillForQty(q);
        if (match) setActive(match);
        else {
          // keine passende Pack-Stufe → Auswahl aufheben, Hint leeren
          for (var i = 0; i < pills.length; i++) {
            pills[i].classList.remove('is-active');
            pills[i].setAttribute('aria-pressed', 'false');
          }
          if (hint) hint.textContent = '';
        }
      });
    }

    // Initialzustand: serverseitig aktive Pill (qty 1) → Hint einmalig setzen.
    var initial = pack.querySelector('[data-pack-pill].is-active') || pillForQty(1);
    if (initial) setActive(initial);
  }

  // =========================================================================
  // BUNDLE-SIZE-SWITCHER (Größen-Pills = echte Links; nur Tastatur-Komfort)
  // =========================================================================
  function initSizeSwitcher() {
    var sw = root.querySelector('[data-bundle-size-switcher]');
    if (!sw) return;
    // Aktive Größe ist serverseitig gesetzt (aria-current/is-active). Pfeiltasten zwischen
    // den Pills für Tastatur-Nutzer; Enter/Klick folgt dem nativen Link.
    var pills = Array.prototype.slice.call(sw.querySelectorAll('[data-bundle-size]'));
    var links = pills.filter(function (el) { return el.tagName === 'A'; });
    if (links.length < 1) return;

    sw.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var idx = links.indexOf(document.activeElement);
      if (idx === -1) return;
      e.preventDefault();
      var next = e.key === 'ArrowRight' ? idx + 1 : idx - 1;
      if (next < 0) next = links.length - 1;
      if (next >= links.length) next = 0;
      links[next].focus();
    });
  }

  initPack();
  initSizeSwitcher();
})();
